import { makeStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: theme.spacing(3),
    backgroundColor: "#F6F8FA",
    background: "linear-gradient(135deg, #F6F8FA 0%, #E8F0FE 100%)",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  container: {
    maxWidth: 600,
    padding: theme.spacing(4),
    backgroundColor: "white",
    borderRadius: 24,
    boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.08)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3),
      margin: theme.spacing(2),
      borderRadius: 16,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      background: "linear-gradient(90deg, #4CAF50 0%, #8BC34A 100%)",
    },
  },
  icon: {
    fontSize: 80,
    color: "#4CAF50",
    marginBottom: theme.spacing(3),
    animation: "$scaleIn 0.5s ease-out",
    [theme.breakpoints.down("xs")]: {
      fontSize: 60,
      marginBottom: theme.spacing(2),
    },
  },
  errorIcon: {
    fontSize: 80,
    color: "#F59E0B",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      fontSize: 60,
      marginBottom: theme.spacing(2),
    },
  },
  tourIcon: {
    width: 96,
    height: 96,
    borderRadius: 20,
    objectFit: "cover",
    marginBottom: theme.spacing(3),
    border: "1px solid rgba(0, 0, 0, 0.08)",
    [theme.breakpoints.down("xs")]: {
      width: 76,
      height: 76,
      marginBottom: theme.spacing(2),
    },
  },
  codeBox: {
    backgroundColor: "#EEF2FF",
    border: "2px solid #5E77FF",
    borderRadius: 16,
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
  },
  codeLabel: {
    fontSize: "0.875rem",
    color: "#3F51B5",
    marginBottom: theme.spacing(0.5),
  },
  codeValue: {
    fontSize: "2.25rem",
    fontWeight: 700,
    letterSpacing: "0.15em",
    color: "#1A237E",
    // Le code est fait pour être recopié dans l'application mobile.
    userSelect: "all",
    wordBreak: "break-all",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.6rem",
    },
  },
  codePendingBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    backgroundColor: "#F8F9FA",
    borderRadius: 16,
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    border: "1px solid rgba(0, 0, 0, 0.05)",
  },
  codePendingText: {
    fontSize: "0.95rem",
    color: "#697386",
  },
  downloadSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // Le bouton touchait le bloc suivant : on isole la section pour lui
    // donner sa propre respiration.
    marginBottom: theme.spacing(4),
  },
  storeButton: {
    marginTop: theme.spacing(1.5),
    padding: "10px 28px",
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.95rem",
    color: "#3F51B5",
    borderColor: "#3F51B5",
    "&:hover": {
      borderColor: "#32408F",
      backgroundColor: "rgba(63, 81, 181, 0.04)",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px 20px",
      fontSize: "0.875rem",
    },
  },
  pdfError: {
    fontSize: "0.8rem",
    color: "#DC2626",
    marginTop: theme.spacing(1),
  },
  customText: {
    textAlign: "left",
    backgroundColor: "#F8F9FA",
    borderRadius: 16,
    padding: theme.spacing(2.5),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: "1px solid rgba(0, 0, 0, 0.05)",
    color: "#2A3142",
    fontSize: "0.95rem",
    lineHeight: 1.6,
    wordBreak: "break-word",
    "& p": {
      margin: 0,
      marginBottom: theme.spacing(1),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    "& ul, & ol": {
      marginTop: 0,
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
    "& a": {
      color: "#3F51B5",
      wordBreak: "break-all",
    },
  },
  contactBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    textAlign: "left",
    backgroundColor: "#EEF2FF",
    padding: theme.spacing(2),
    borderRadius: 16,
    border: "1px solid rgba(63, 81, 181, 0.15)",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
      borderRadius: 12,
    },
  },
  contactIcon: {
    fontSize: 32,
    color: "#3F51B5",
    flexShrink: 0,
  },
  contactLabel: {
    fontSize: "0.875rem",
    color: "#2A3142",
  },
  contactLink: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#3F51B5",
    wordBreak: "break-all",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    fontSize: "2rem",
    color: "#1A237E",
    animation: "$fadeIn 0.5s ease-out 0.2s both",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      marginBottom: theme.spacing(1),
    },
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    animation: "$fadeIn 0.5s ease-out 0.4s both",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      marginBottom: theme.spacing(2),
    },
  },
  infoBox: {
    backgroundColor: "#F8F9FA",
    padding: theme.spacing(3),
    borderRadius: 16,
    marginBottom: theme.spacing(3),
    textAlign: "left",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    animation: "$slideUp 0.5s ease-out 0.6s both",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: 12,
    },
  },
  list: {
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(1),
    },
  },
  listItem: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(1.5),
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  listItemIcon: {
    minWidth: 40,
    marginTop: 4,
    [theme.breakpoints.down("xs")]: {
      minWidth: 32,
    },
  },
  listItemText: {
    color: "#2A3142",
    fontSize: "0.95rem",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  button: {
    marginTop: theme.spacing(2),
    padding: "12px 32px",
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "1rem",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    animation: "$fadeIn 0.5s ease-out 0.8s both",
    [theme.breakpoints.down("xs")]: {
      padding: "10px 24px",
      fontSize: "0.875rem",
      marginTop: theme.spacing(1.5),
    },
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.15)",
    },
  },
  "@keyframes scaleIn": {
    "0%": {
      transform: "scale(0)",
      opacity: 0,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
      transform: "translateY(10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@keyframes slideUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(20px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
});

export default styles;
